import {useState} from 'react';  

export default function SavedConfigurations({product, cart, productLink, canEdit, open, setOpen})  {
  const [partNumbers, setPartNumbers] = useState(() =>  {
    let partNumbers = []
    if (product.part_numbers?.length > 0 ) {
      partNumbers =  product.part_numbers.map((d, i) => {

        let partNumber = d.replace(/\|/g, ' - ').replace(/\:/g, ''); 
        let editLink = productLink + `?sku_parts=${encodeURIComponent(d)}#lexcms-configurator-section` 
        return  {original: d, editLink: editLink, partNumber: partNumber}
      })

    }
    return partNumbers
  })

  const removePart = async (part) => {
    let ans =  confirm('Are you sure?');  
    if (ans) {
      let success = await cart.removePart(product.id, part)
      setPartNumbers((old) => old.filter((data) => data.original !== part )) 
    }
  }

  return (
    <div className='lexcms-parts-dropdown'>
     <div className='lexcms-parts-header'> 
       <div><strong> Configurations: </strong> <span>({partNumbers.length}) </span></div>
       <button onClick={()=>setOpen(false)}>Hide Configurations 
         <span className={`lexcms-accordion-arrow --open`}></span>
       </button>
     </div>
     {partNumbers.map((part, i) => {
        return (<div key={i} className='lexcms-part-container'> 
          <div className='lexcms-part-number-display'> 
            <div className='lexcms-part-number'>{part.partNumber}</div>
            {canEdit && 
            <div className='lexcms-part-actions'>
              <a href={part.editLink}>View</a>
              <a onClick={( ) => removePart(part.original)}>Delete</a>
            </div>
            }
          </div>
        </div>)
      })
      }
    </div>
  )

}
